export const Locales = {
	DE: 'de',
	EN: 'en',
	FR: 'fr',
	IT: 'it',
	ES: 'es',
	CA: 'ca',
};
